let team = {
    final_year:[{
        name:"Mohd. Uvesh",
        bio:"bio",
        post:"Sec",
        img:"https://i.ibb.co/0nQqZ1V/IMG-20200926-134504.jpg",
        linkedin:"https://www.linkedin.com/in/mohd-uvesh-1b1b1b1b1/",
        github:""
    }],
    third_year:[{
        name:"Nitin Sohal",
        bio:"bio",
        post:"CC",
        img:"https://i.ibb.co/0nQqZ1V/IMG-20200926-134504.jpg",
        linkedin:"https://www.linkedin.com/in/mohd-uvesh-1b1b1b1b1/",
        github:""
    },
    
]
}
export default team